import { render, staticRenderFns } from "./AvatarCropModal.vue?vue&type=template&id=71daef52&scoped=true&"
import script from "./AvatarCropModal.vue?vue&type=script&lang=ts&"
export * from "./AvatarCropModal.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarCropModal.vue?vue&type=style&index=0&id=71daef52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71daef52",
  null
  
)

export default component.exports